import { VFC } from "react";

import LastRefreshedAtText from "components/LastRefreshedAtText";
import RefetchButton from "components/RefetchButton";
import SimpleSearchView from "components/SimpleSearchView";
import ModeButtonGroup from "pages/shipper/components/ModeButtonGroup";
import { TransportationMode } from "pages/shipper/pages/quotes/types/TransportationMode";
import FiltersAppBar from "utils/layout/FiltersAppBar";

import { BrokerBidsIndexFilterState } from "../store/brokerBidsIndexFilterSlice";

interface BrokerBidsFilterBarViewProps {
  filters?: JSX.Element;
  transportationMode: TransportationMode;
  searchQuery: string;
  lastRefreshedAt?: string;
  isLoading: boolean;

  onChangeFilter: (changes: Partial<BrokerBidsIndexFilterState>) => void;
  onRefresh: () => void;
}

const BrokerBidsFilterBarView: VFC<BrokerBidsFilterBarViewProps> = ({
  filters,
  transportationMode,
  searchQuery,
  lastRefreshedAt,
  isLoading,
  onChangeFilter,
  onRefresh,
}) => {
  return (
    <FiltersAppBar>
      <div className="flex justify-between">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-2">
          <ModeButtonGroup
            value={transportationMode}
            onChange={(transportationMode) => onChangeFilter({ transportationMode })}
            includeModes={[TransportationMode.INTERMODAL]}
            disabledModes={[
              TransportationMode.Trucking,
              TransportationMode.LTL,
              TransportationMode.DRAYAGE,
              TransportationMode.Ocean,
              TransportationMode.Air,
            ]}
          />
          <SimpleSearchView
            search={searchQuery}
            onChange={(searchQuery) => onChangeFilter({ searchQuery })}
            placeholder={"Search"}
          />
          {filters}
        </div>
        <div className="whitespace-nowrap flex grow items-center justify-end">
          {lastRefreshedAt && <LastRefreshedAtText value={lastRefreshedAt} />}
          <div>
            <RefetchButton loading={isLoading} onClick={onRefresh} />
          </div>
        </div>
      </div>
    </FiltersAppBar>
  );
};

export default BrokerBidsFilterBarView;
